<template>
  <div class="row">
    <div class="col-12 col-sm-7">
      <label :for="`dish-${dish.id}`">
        {{dish.name}}
      </label>
      <p class="text text-danger" v-if="!validateMinimumQuantity">注文数が不足してます。</p>
    </div>
    <div class="col-5 col-sm-2">{{dish.price | currency}}</div>
    <div class="col-7 col-sm-3">
      <div class="input-group">
        <input :id="`dish-${dish.id}`" type="number" min="0"  class="form-control" v-model="quantity" @input="onChange" inputmode="numeric">
        <div class="input-group-append">
          <span class="input-group-text">{{dish.unit_name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      dish: Object,
      minimumQuantity: Number,
      handleDish: Function,
      calculate: Function
    },
    data() {
      return {
        quantity: ''
      }
    },
    computed: {
      validateMinimumQuantity() {
        if (this.dish.unit_name !== '人') return true
        if (this.quantity === '') return true
        return this.quantity >= this.minimumQuantity;
      },
    },
    methods: {
      onChange() {
        const { name, price, unit_name } = this.dish
        const quantity = this.quantity
        this.$emit('handleDish', { name, price, unit_name, quantity })
        this.$emit('calculate')
      }
    }
  }
</script>